import React, { useState } from 'react';
import { IoSparkles } from 'react-icons/io5';
import { Dialog } from '../../../components/Dialog';
import AiAssistChat from './AiAssistChat';
import { moduleEnabledOrOpenIntercom } from '../../helpers/validate_module';

interface AiAssistProps {
  moduleContracted: boolean;
}

export const AiAssistButton: React.FC<AiAssistProps> = ({ moduleContracted }) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [load, setLoad] = useState<boolean>(false);

  const handleOpenModal = () => {
    const successCallback = () => {
      setModalOpen(true);
      setLoad(true);
    };

    moduleEnabledOrOpenIntercom(
      moduleContracted,
      successCallback,
      'Olá! Quero usar a Manu IA para criar os formulários no sistema. ' +
        'Perco muito tempo definindo os campos e ela pode sugerir isso automaticamente.\n' +
        'Pode me explicar como contratar?'
    );
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <button className="produttivo-btn" onClick={handleOpenModal}>
        <IoSparkles fontSize={'1.25em'} />
        Pedir sugestão à IA
      </button>

      <Dialog isOpen={modalOpen} onClose={handleCloseModal} isBeta={true} title="IA Produttivo">
        <AiAssistChat loadMessages={load} closeModal={handleCloseModal} />
      </Dialog>
    </>
  );
};
